
import { useState } from 'react';

const Memorial2025 = () => {
  return (
    <section id="events" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-4xl font-bold text-[#1C1C1C] mb-6">
                故總統嚴家淦先生一百二十歲冥誕紀念新書發表暨3D文物數位典藏開箱活動
              </h2>
              
              <div className="bg-white rounded-2xl shadow-lg p-8">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-12 h-12 bg-[#C2A97A] rounded-full flex items-center justify-center">
                    <i className="ri-calendar-event-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1C1C1C]">114年11月14日至114年12月24日</h3>
                    <p className="text-gray-600">誕辰120週年紀念</p>
                  </div>
                </div>

                <p className="text-gray-700 leading-relaxed mb-4">
                  為紀念故總統嚴家淦先生誕辰一百二十週年，社團法人嚴前總統家淦先生紀念協會特於2025年11月14日假國定古蹟自由之家舉辦「嚴家淦先生一百二十歲冥誕紀念新書發表暨3D文物數位典藏開箱活動」。活動當日除舉行追思儀式外，並同步發表新書《靜波人生──嚴前總統家淦先生財經與施政言論選集》，精選先生在財經與施政方面的重要文獻一百二十篇，展現其以穩健、務實精神推動國家建設的歷程。
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                  本次活動亦結合文化與科技創新，與光陣三維科技及台北科技大學合作，首次公開先生故居及珍貴文物的3D數位典藏成果，透過虛擬實境與擴增實境技術，讓歷史重現於眼前，體現「科技讓文化被看見，也讓感動被傳遞」的理念。活動期盼讓更多民眾重新認識嚴前總統為國為民的風範，並延續其清廉、敬業、厚德載物的典範精神。
                </p>

                <div className="mb-6">
                  <h4 className="text-lg font-bold text-[#1C1C1C] mb-4">活動內容</h4>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <i className="ri-gallery-line text-[#C2A97A] text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <div>
                        <p className="font-semibold text-gray-800">文物展覽|《嚴家淦先生書房》</p>
                        <p className="text-sm text-gray-600">
                          展示嚴家淦文物收藏歷史影像，重現戰後重建與財政改革的關鍵時刻。
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-camera-line text-[#C2A97A] text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <div>
                        <p className="font-semibold text-gray-800">攝影作品|《攝影家的靜波心境》</p>
                        <p className="text-sm text-gray-600">
                          鏡頭所見，不僅是景，更是心。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <div className="flex items-center space-x-2 mb-2">
                    <i className="ri-map-pin-line text-[#C2A97A] text-lg w-5 h-5 flex items-center justify-center"></i>
                    <span className="font-semibold text-gray-800">地點:</span>
                    <span className="text-gray-700">嚴家淦紀念園區-國定古蹟自由之家展區</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-calendar-line text-[#C2A97A] text-lg w-5 h-5 flex items-center justify-center"></i>
                    <span className="font-semibold text-gray-800">時間:</span>
                    <span className="text-gray-700">114年11月17日至114年12月24日止</span>
                  </div>
                </div>

                <button className="inline-flex items-center justify-center font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap bg-[#C2A97A] text-white hover:bg-[#B39968] px-8 py-4 text-lg rounded-xl w-full">
                  活動詳情
                </button>
              </div>
            </div>

            <div className="flex items-center justify-center">
              <div className="relative">
                <img
                  alt="靜波人生 - 嚴家淦總統歷史照片"
                  className="w-full h-[60rem] object-cover object-top rounded-2xl shadow-2xl"
                  src="https://static.readdy.ai/image/daf2c8ebc95be5bc3480a922a1310657/441b51edc870e2a1b8c44cae8ebbeb2f.jpeg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
                <div className="absolute bottom-6 left-6 text-white">
                  <h4 className="text-xl font-bold mb-1">靜波人生</h4>
                  <p className="text-sm opacity-90">前總統嚴家淦先生120週年紀念</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Memorial2025;
